/* ============================================================
   I LIBRI CURIOSI · script del tema (bozza C di "100.000 perché")
   Portato il 30/10/2026 dallo script della bozza
   (progetti/prossimo-libro/sito/bozza/direzione-c/index.html).
   Un solo file per tutte le pagine: ogni pezzo parte solo se trova i suoi
   elementi. Nessuna libreria. Le classi sono tutte lc-*.
   Dati veri in window.LC (snippets/lc-dati.liquid).
   31/10/2026: home, schede degli ebook, omaggi contati sulle copie totali.
   1. utilità
   2. timer fino a mezzanotte e date vere di spedizione e consegna
   3. galleria
   4. sfoglia il libro (a tutto schermo)
   5. scelta dell'offerta e barra fissa
   6. carrello (pannello di Horizon e pagina /cart, disegnati da /cart.js)
   ============================================================ */
(() => {
'use strict';

/* ---------- 1. utilità ---------- */
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
const CFG = window.LC || {};
const euro = c => (Math.round(c) / 100).toFixed(2).replace('.', ',') + ' €';   // 2995 -> "29,95 €"
const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]));
const VARIANTI = (CFG.libro && CFG.libro.varianti) || [];
const VAR = {}; VARIANTI.forEach(v => { VAR[v.id] = v; });
const perCopie = n => VARIANTI.find(v => v.copie === n);
const largo = () => matchMedia('(min-width: 990px)').matches;   // sopra: il pannello di Horizon non è modale

function avviso(t){
  const a = $('[data-lc-avviso]'); if (!a) return;
  a.textContent = t; a.classList.add('lc-on');
  clearTimeout(avviso.t); avviso.t = setTimeout(() => a.classList.remove('lc-on'), 3200);
}
/* blocco dello scorrimento: sopra i 990 px Horizon fa scorrere .page-wrapper, non la finestra */
function blocca(on){ document.body.classList.toggle('lc-bloccato', !!on); }

/* ---------- 2. timer e date ---------- */
function oraRoma(){
  const p = Object.fromEntries(new Intl.DateTimeFormat('it-IT', { timeZone:'Europe/Rome', year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit', second:'2-digit', hourCycle:'h23' }).formatToParts(new Date()).map(x => [x.type, x.value]));
  return { y:+p.year, m:+p.month, d:+p.day, h:+p.hour, mi:+p.minute, s:+p.second };
}
function tick(){
  const t = oraRoma();
  const rest = 86400 - (t.h * 3600 + t.mi * 60 + t.s);
  const hh = String(Math.floor(rest / 3600)).padStart(2, '0'), mm = String(Math.floor(rest % 3600 / 60)).padStart(2, '0'), ss = String(rest % 60).padStart(2, '0');
  $$('.lc-conta').forEach(c => { c.textContent = hh + ':' + mm + ':' + ss; });
}
if ($$('.lc-conta').length) { tick(); setInterval(tick, 1000); }

/* giorni lavorativi: senza sabato, domenica e feste nazionali */
function pasqua(y){ const a=y%19,b=Math.floor(y/100),c=y%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),mo=Math.floor((h+l-7*m+114)/31),da=((h+l-7*m+114)%31)+1; return new Date(Date.UTC(y,mo-1,da)); }
function festa(dt){
  const md = String(dt.getUTCMonth() + 1).padStart(2, '0') + '-' + String(dt.getUTCDate()).padStart(2, '0');
  if (['01-01','01-06','04-25','05-01','06-02','08-15','11-01','12-08','12-25','12-26'].includes(md)) return true;
  const p = pasqua(dt.getUTCFullYear()); p.setUTCDate(p.getUTCDate() + 1);   // lunedì dell'Angelo
  return +p === +dt;
}
function lavorativo(dt){ const g = dt.getUTCDay(); return g !== 0 && g !== 6 && !festa(dt); }
function piuLavorativi(dt, n){ const d = new Date(dt); while (n > 0) { d.setUTCDate(d.getUTCDate() + 1); if (lavorativo(d)) n--; } return d; }
const fmtData = (d, mese = true) => new Intl.DateTimeFormat('it-IT', mese ? { weekday:'short', day:'numeric', month:'short', timeZone:'UTC' } : { weekday:'short', day:'numeric', timeZone:'UTC' }).format(d);
if ($('.lc-d-oggi')) {
  const t = oraRoma(), oggi = new Date(Date.UTC(t.y, t.m - 1, t.d));
  /* Nicola, 4/11/2026: "consegniamo in 3-4 giorni massimo", come Studio della Bibbia (che per un
     ordine del 4 mostra spedito 4-5, consegnato 6-7): spedito entro il giorno lavorativo dopo,
     consegnato fra 2 e 3 giorni lavorativi dall'ordine */
  const sped = piuLavorativi(oggi, 1), c1 = piuLavorativi(oggi, 2), c2 = piuLavorativi(oggi, 3);
  $$('.lc-d-oggi').forEach(e => { e.textContent = 'oggi, ' + fmtData(oggi); });
  $$('.lc-d-sped').forEach(e => { e.textContent = 'entro ' + fmtData(sped); });
  $$('.lc-d-cons').forEach(e => { e.textContent = fmtData(c1, c1.getUTCMonth() !== c2.getUTCMonth()) + ' - ' + fmtData(c2); });
}

/* ---------- 3. galleria ---------- */
const gal = $('[data-lc-gal-track]');
if (gal && gal.children.length) {
  const nSlide = gal.children.length;
  const mini = $$('[data-lc-gal-mini] button');
  const puntiEl = $('[data-lc-gal-punti]');
  if (puntiEl) puntiEl.innerHTML = Array.from(gal.children).map((_, k) => '<button type="button" aria-label="Immagine ' + (k + 1) + '"' + (k ? '' : ' class="lc-on"') + '></button>').join('');
  const punti = $$('button', puntiEl || document.createElement('div'));
  const numEl = $('[data-lc-gal-num]');
  const passo = () => nSlide > 1 ? gal.children[1].offsetLeft - gal.children[0].offsetLeft : gal.clientWidth;
  const vai = i => { i = Math.max(0, Math.min(nSlide - 1, i)); gal.scrollTo({ left: i * passo(), behavior: 'smooth' }); };
  let galI = 0;
  gal.addEventListener('scroll', () => {
    const fine = gal.scrollLeft + gal.clientWidth >= gal.scrollWidth - 4;
    const i = fine ? nSlide - 1 : Math.round(gal.scrollLeft / passo());
    if (i === galI) return;
    galI = i;
    if (numEl) numEl.textContent = (i + 1) + ' / ' + nSlide;
    mini.forEach((m, k) => m.classList.toggle('lc-on', k === i));
    punti.forEach((m, k) => m.classList.toggle('lc-on', k === i));
    if (mini[i] && getComputedStyle(mini[i].parentElement).display !== 'none') mini[i].parentElement.scrollTo({ left: mini[i].offsetLeft - 60, behavior: 'smooth' });
  }, { passive: true });
  mini.forEach((m, k) => m.addEventListener('click', () => vai(k)));
  punti.forEach((m, k) => m.addEventListener('click', () => vai(k)));
  $$('[data-gal]').forEach(b => b.addEventListener('click', () => vai(galI + +b.dataset.gal)));
}

/* ---------- 4. sfoglia il libro ---------- */
const sf = $('[data-lc-sf-track]');
const lente = $('[data-lc-lente]');
const lenteAperta = () => !!(lente && lente.classList.contains('lc-on'));
if (sf && lente) {
  const pag = $$('.lc-pag', sf);
  const img = $('[data-lc-lente-img]', lente), tit = $('[data-lc-lente-tit]', lente), num = $('[data-lc-lente-n]', lente);
  let li = 0;
  const mostra = i => {
    li = (i + pag.length) % pag.length;
    const b = pag[li];
    img.src = b.dataset.grande;
    img.alt = (b.dataset.tit || '').split(' · ')[0].replace('p.', 'Pagina');
    tit.textContent = b.dataset.tit || '';
    num.textContent = (li + 1) + ' / ' + pag.length;
  };
  const chiudiLente = () => { lente.classList.remove('lc-on'); blocca(false); aggiornaBarra(); };
  $$('[data-sf]').forEach(b => b.addEventListener('click', () => sf.scrollBy({ left: +b.dataset.sf * sf.clientWidth * .8, behavior: 'smooth' })));
  sf.addEventListener('click', e => {
    const b = e.target.closest('.lc-pag'); if (!b) return;
    mostra(+b.dataset.i); lente.classList.add('lc-on'); blocca(true); aggiornaBarra();
  });
  $('[data-lc-lente-chiudi]', lente).addEventListener('click', chiudiLente);
  $('[data-lc-lente-sx]', lente).addEventListener('click', () => mostra(li - 1));
  $('[data-lc-lente-dx]', lente).addEventListener('click', () => mostra(li + 1));
  lente.addEventListener('click', e => { if (e.target === lente) chiudiLente(); });
  let tx = null;
  lente.addEventListener('touchstart', e => { tx = e.touches.length === 1 ? e.touches[0].clientX : null; }, { passive: true });
  lente.addEventListener('touchend', e => { if (tx === null) return; const dx = e.changedTouches[0].clientX - tx; if (Math.abs(dx) > 45) mostra(li + (dx < 0 ? 1 : -1)); tx = null; });
  document.addEventListener('keydown', e => {
    if (!lenteAperta()) return;
    if (e.key === 'Escape') chiudiLente();
    if (e.key === 'ArrowLeft') mostra(li - 1);
    if (e.key === 'ArrowRight') mostra(li + 1);
  });
}

/* ---------- 5. scelta dell'offerta (le due liste vanno insieme) e barra fissa ---------- */
const primaScelta = $('.lc-carta.lc-on');
let scelta = primaScelta ? +primaScelta.dataset.id : ((perCopie(2) || VARIANTI[0] || {}).id || 0);
function scegli(id){
  scelta = +id;
  $$('.lc-carta, .lc-mini').forEach(c => {
    const on = +c.dataset.id === scelta;
    c.classList.toggle('lc-on', on);
    const i = $('input', c); if (i) i.checked = on;
  });
  const o = VAR[scelta]; if (!o) return;
  sblocca(o.copie);
  const q = $('[data-lc-barra-q]'), p = $('[data-lc-barra-p]'), s = $('[data-lc-barra-s]');
  if (q) q.textContent = o.nome + (o.copie > 1 ? ' · sped. gratis' : ' + ' + (CFG.spedizione / 100) + ' € sped.');
  if (p) p.textContent = euro(o.prezzo);
  if (s) s.textContent = euro(o.barrato);
}
/* OMAGGI DA SBLOCCARE (31/10/2026, seconda prova di Nicola): sotto le carte una striscia sola con i
   quattro omaggi; quelli che l'offerta scelta non dà restano grigi col lucchetto, gli altri si
   accendono con un piccolo salto. Le regole sono quelle della mail di conferma (diploma da 1 copia, tutti gli ebook da 2, dal 4/11/2026). */
function sblocca(copie){
  const box = $('[data-lc-sblocca]'); if (!box) return;
  const voci = $$('li[data-da]', box);
  let n = 0;
  voci.forEach(li => {
    const on = copie >= +li.dataset.da;
    if (on) n++;
    if (on && !li.classList.contains('lc-sb-on')) { li.classList.remove('lc-sb-pop'); void li.offsetWidth; li.classList.add('lc-sb-pop'); }
    li.classList.toggle('lc-sb-on', on);
  });
  const conta = $('[data-lc-sb-conta]', box);
  if (conta) conta.textContent = n + ' di ' + voci.length + ' sbloccati';
  const nota = $('[data-lc-sb-nota]', box);
  if (nota) nota.innerHTML = copie >= 2
    ? 'Hai sbloccato tutti gli omaggi: <b>' + euro(+box.dataset.valore || 0) + '</b> di ebook gratis.'
    : 'Con <b>2 copie</b> sblocchi tutti e 3 gli ebook.';
}
$$('.lc-carta input, .lc-mini input').forEach(i => i.addEventListener('change', () => scegli(i.value)));
if (scelta) scegli(scelta);

function aggiornaBarra(){
  const barra = $('[data-lc-barra]'), off = $('[data-lc-offerte]'), fin = $('[data-lc-mini-carte]');
  if (!barra || !off || !fin) return;
  const r = off.getBoundingClientRect(), f = fin.getBoundingClientRect(), vh = innerHeight;
  const passate = r.bottom < 60;
  const finVis = f.top < vh && f.bottom > 0;
  /* portatili (collaudo 4/11/2026): a 1280 x 720 il pulsante vero sta sotto la piega e nella
     prima schermata non si poteva comprare. Solo sopra i 990 px: il telefono resta com'è */
  const btn = largo() && $('[data-da="principale"]');
  const sotto = !!btn && btn.getBoundingClientRect().top > vh - barra.offsetHeight;
  barra.classList.toggle('lc-on', (passate || sotto) && !finVis && !carrelloAperto() && !lenteAperta());
}
/* lo scorrimento può essere della finestra o di .page-wrapper (Horizon sopra i 990 px):
   si ascolta in cattura su tutto il documento */
document.addEventListener('scroll', aggiornaBarra, { passive: true, capture: true });
addEventListener('resize', aggiornaBarra);

/* ---------- 6. carrello ---------- */
let cart = null;
try { cart = JSON.parse(($('[data-lc-cart-json]') || {}).textContent || 'null'); } catch (e) { cart = null; }
const isLibro = it => !!(CFG.libro && it.product_id === CFG.libro.id && VAR[it.variant_id]);
const EBOOK = CFG.ebook || [];
const ebookDi = it => EBOOK.find(e => e.id === it.product_id) || null;
/* copie del libro nel carrello: variante × quantità ("2 copie" × 2 = 4) */
const copieLibro = c => (c ? c.items : []).filter(isLibro).reduce((s, it) => s + VAR[it.variant_id].copie * it.quantity, 0);
/* il pallino conta le copie del libro e gli altri articoli uno per uno */
const copieTot = c => (c ? c.items : []).reduce((s, it) => s + (isLibro(it) ? VAR[it.variant_id].copie : 1) * it.quantity, 0);
/* omaggi (31/10/2026): da 1 copia il diploma, da 2 anche «30 esperimenti», da 3 anche quiz e colorare */
const SOGLIE = CFG.soglie || { diploma: 1, esp: 2, quiz: 2, col: 2 };
const omaggiPer = copie => ({ diploma: copie >= SOGLIE.diploma, ebook: EBOOK.filter(e => copie >= (SOGLIE[e.chiave] || 99)) });
/* stessa regola delle tariffe del negozio: 7 € sotto i 39,90 € di carrello (ebook compresi,
   verificato con le tariffe di Shopify il 31/10/2026), gratis da 39,90 € (31/10/2026 sera: libro + un ebook = spedizione gratis); solo ebook: nessuna spedizione */
const spedizione = c => (c.items.some(it => it.requires_shipping) && c.total_price < CFG.soglia) ? CFG.spedizione : 0;

async function api(url, body){
  const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.description || d.message || 'Qualcosa non ha funzionato. Riprova.');
  return d;
}
async function carica(){
  const r = await fetch(CFG.rotte.cart, { headers: { Accept: 'application/json' }, cache: 'no-store' });
  cart = await r.json();
  return cart;
}

/* LE COPIE DEL LIBRO (31/10/2026, collaudo): "+" e "−" cambiano il numero TOTALE di copie e il
   carrello lo scompone sempre nelle offerte più convenienti: più "3 copie" possibili, poi
   "2 copie" o "1 copia" (4 = 3+1, 5 = 3+2, 6 = 3+3). Così 2 copie costano 54,95 € e non 2 × 29,95. */
function scomponi(N){
  const q = {}; VARIANTI.forEach(v => { q[v.id] = 0; });
  const tre = perCopie(3), due = perCopie(2), uno = perCopie(1);
  let n = Math.max(0, N);
  if (tre) { q[tre.id] = Math.floor(n / 3); n = n % 3; }
  if (n === 2 && due) q[due.id] += 1;
  else if (n && uno) q[uno.id] += n;
  return q;
}
const quantitaLibro = c => { const q = {}; VARIANTI.forEach(v => { q[v.id] = 0; }); c.items.filter(isLibro).forEach(it => { q[it.variant_id] += it.quantity; }); return q; };
const ottimale = c => { const a = quantitaLibro(c), b = scomponi(copieLibro(c)); return VARIANTI.every(v => a[v.id] === b[v.id]); };
const prezzoLibro = N => VARIANTI.reduce((s, v) => s + v.prezzo * (scomponi(N)[v.id] || 0), 0);
async function impostaCopie(N){ await api(CFG.rotte.update, { updates: scomponi(N) }); }

/* AGGIUNGI (31/10/2026): Nicola ha visto due volte "Il prodotto '100.000 perché - 2 copie' è già
   esaurito", che da un browser pulito non succede mai (il libro si vende senza limiti di magazzino).
   Sul forum degli sviluppatori di Shopify è un difetto noto: un carrello rimasto bloccato da
   un'aggiunta andata male risponde "esaurito" a /cart/add.js finché non si svuota. Quindi:
   1) /cart/add.js; 2) se rifiuta, /cart/update.js con la quantità nuova; 3) se rifiuta ancora, si
   svuota il carrello e si rimette tutto, e se nemmeno così passa, solo la riga nuova. */
async function aggiungi(id){
  try { return await api(CFG.rotte.add, { items: [{ id, quantity: 1 }] }); }
  catch (e1) {
    await carica().catch(() => {});
    const righe = cart ? cart.items : [];
    const gia = righe.filter(it => it.variant_id === id).reduce((s, it) => s + it.quantity, 0);
    try { return await api(CFG.rotte.update, { updates: { [id]: gia + 1 } }); }
    catch (e2) {
      const altre = righe.filter(it => it.variant_id !== id).map(it => ({ id: it.variant_id, quantity: it.quantity, properties: it.properties || {} }));
      await api(CFG.rotte.clear, {});
      try { return await api(CFG.rotte.add, { items: altre.concat([{ id, quantity: gia + 1 }]) }); }
      catch (e3) { return await api(CFG.rotte.add, { items: [{ id, quantity: gia + 1 }] }); }
    }
  }
}

/* EBOOK GIÀ IN OMAGGIO (31/10/2026, collaudo): se un ebook comprato è fra gli omaggi delle copie
   nel carrello, si toglie da solo e il carrello lo dice, così non si paga due volte */
let tolti = [];
const doppi = c => { const reg = new Set(omaggiPer(copieLibro(c)).ebook.map(e => e.chiave)); return c.items.filter(it => { const e = ebookDi(it); return e && reg.has(e.chiave); }); };
const daSistemare = c => !!c && ((c.items.some(isLibro) && !ottimale(c)) || doppi(c).length > 0);
async function sistema(){
  if (cart.items.some(isLibro) && !ottimale(cart)) { await impostaCopie(copieLibro(cart)); await carica(); }
  const d = doppi(cart);
  if (d.length) {
    const upd = {}; d.forEach(it => { upd[it.variant_id] = 0; });
    await api(CFG.rotte.update, { updates: upd });
    tolti = d.map(it => ebookDi(it).titolo);
    await carica();
  }
}
async function caricaESistema(){ await carica(); await sistema(); return cart; }

const ICO = (id, px) => '<svg class="lc-ico"' + (px ? ' style="width:' + px + 'px;height:' + px + 'px"' : '') + '><use href="#lc-i-' + id + '"/></svg>';
const QTA = (attr, n, piu, meno) => '<div class="lc-qta"><button type="button" ' + attr + '="' + meno + '" aria-label="Togli">' + ICO('meno', 16) + '</button><span>' + n + '</span><button type="button" ' + attr + '="' + piu + '" aria-label="Aggiungi">' + ICO('piu', 16) + '</button></div>';

/* una riga sola per il libro, con le copie in tutto ("4 libri") e le offerte che le compongono */
function rigaLibro(libri){
  const N = copieLibro(cart);
  const prezzo = libri.reduce((s, it) => s + it.original_line_price, 0);
  const barrato = libri.reduce((s, it) => s + VAR[it.variant_id].barrato * it.quantity, 0);
  const parti = [];
  VARIANTI.slice().sort((x, y) => y.copie - x.copie).forEach(v => { libri.filter(it => it.variant_id === v.id).forEach(it => { for (let i = 0; i < it.quantity; i++) parti.push(v.nome); }); });
  const sotto = parti.length > 1 ? 'Offerte ' + parti.join(' + ') : 'Libro cartaceo, 192 pagine';
  return '<div class="lc-riga-car"><img class="lc-libri" src="' + esc(CFG.immagini[Math.min(N, 3)]) + '" alt="" width="64" height="64">' +
    '<div class="lc-det"><b>' + esc(libri[0].product_title) + ' · ' + N + (N === 1 ? ' libro' : ' libri') + '</b><small>' + esc(sotto) + '</small>' + QTA('data-lc-copie', N, N + 1, N - 1) + '</div>' +
    '<div class="lc-pz"><b>' + euro(prezzo) + '</b>' + (barrato > prezzo ? '<s>' + euro(barrato) + '</s>' : '') + '<button type="button" class="lc-rimuovi" data-lc-copie="0">Rimuovi</button></div></div>';
}
function riga(it){
  const e = ebookDi(it);
  const proprio = it.featured_image && it.featured_image.url ? it.featured_image.url + (it.featured_image.url.includes('?') ? '&' : '?') + 'width=160' : '';
  const img = e ? (e.img || proprio) : proprio;
  const titolo = e ? 'Ebook «' + esc(it.product_title) + '»' : esc(it.product_title);
  const sotto = e ? 'PDF nella mail di conferma' : esc(it.variant_title || '');
  const barrato = e ? e.barrato * it.quantity : (it.original_line_price || 0);
  const k = esc(it.key);
  return '<div class="lc-riga-car">' + (img ? '<img class="lc-libri' + (e ? ' lc-libri-eb' : '') + '" src="' + esc(img) + '" alt="" width="64" height="64">' : '') +
    '<div class="lc-det"><b>' + titolo + '</b><small>' + sotto + '</small>' + QTA('data-lc-q', it.quantity, (it.quantity + 1) + '" data-key="' + k, (it.quantity - 1) + '" data-key="' + k) + '</div>' +
    '<div class="lc-pz"><b>' + euro(it.original_line_price) + '</b>' + (barrato > it.original_line_price ? '<s>' + euro(barrato) + '</s>' : '') + '<button type="button" class="lc-rimuovi" data-lc-q="0" data-key="' + k + '">Rimuovi</button></div></div>';
}

function disegnaIn(box){
  const corpo = $('[data-lc-car-corpo]', box);
  if (!corpo) return;
  if (!cart.items.length) {
    box.setAttribute('data-vuoto', '');
    const sulLibro = CFG.libro && location.pathname === CFG.libro.url;
    corpo.innerHTML = '<div class="lc-car-vuoto"><img class="lc-adesivo" src="' + esc(CFG.immagini.guidoPensa) + '" alt="" width="90" height="90">Il carrello è vuoto.' +
      (CFG.libro ? '<a class="lc-btn" href="' + esc(CFG.libro.url) + '"' + (sulLibro && box.closest('dialog') ? ' data-lc-chiudi-carrello' : '') + '>Torna al libro</a>' : '') +
      '<a class="lc-vuoto-eb" href="' + esc((CFG.rotte.home || '/') + '#ebook') + '">Gli ebook</a></div>';
    return;
  }
  box.removeAttribute('data-vuoto');
  const copie = copieLibro(cart);
  const om = omaggiPer(copie);
  const libri = cart.items.filter(isLibro);
  /* il libro sempre in cima, poi gli altri articoli (Shopify mette in cima l'ultimo aggiunto) */
  let html = libri.length ? rigaLibro(libri) : '';
  cart.items.forEach(it => { if (!isLibro(it)) html += riga(it); });
  if (om.diploma || tolti.length) {
    const avviso = tolti.map(t => '<p class="lc-avviso-om">L’ebook «' + esc(t) + '» ti arriva già in omaggio: l’abbiamo tolto dal carrello.</p>').join('');
    const righeOm = (om.diploma ? ['<li><img src="' + esc(CFG.diploma.img) + '" alt="" width="42" height="59"><span class="lc-nome">' + esc(CFG.diploma.titolo) + '</span><span class="lc-val"><em>in omaggio</em></span></li>'] : [])
      .concat(om.ebook.map(e => '<li><img src="' + esc(e.mini || e.img) + '" alt="" width="42" height="59"><span class="lc-nome">Ebook «' + esc(e.titolo) + '»</span><span class="lc-val"><s>' + euro(e.prezzo) + '</s><em>GRATIS</em></span></li>'));
    html += '<div class="lc-car-omaggi"><h4><svg class="lc-ico" style="width:18px;height:18px;color:var(--corallo-d)"><use href="#lc-i-regalo"/></svg>In omaggio con questo ordine</h4>' + avviso + '<ul>' + righeOm.join('') + '</ul></div>';
  }
  /* passo in più: con 1 o 2 copie, passare all'offerta successiva (stesso effetto del "+") */
  if (copie === 1 || copie === 2) {
    const a = perCopie(copie + 1);
    if (a) {
      const spedOra = spedizione(cart);
      /* un ebook comprato che con le copie in più diventa omaggio esce dal carrello: non si conta */
      const giaReg = new Set(omaggiPer(copie).ebook.map(e => e.chiave));
      const diventaReg = omaggiPer(copie + 1).ebook.filter(e => !giaReg.has(e.chiave)).map(e => e.chiave);
      const esce = cart.items.filter(it => { const e = ebookDi(it); return e && diventaReg.includes(e.chiave); }).reduce((t, it) => t + it.original_line_price, 0);
      const totDopo = cart.total_price + prezzoLibro(copie + 1) - prezzoLibro(copie) - esce;
      const spedDopo = (totDopo < CFG.soglia) ? CFG.spedizione : 0;
      const diff = (totDopo + spedDopo) - (cart.total_price + spedOra);
      const frase = a.copie === 2 ? ' con ' + euro(diff) + ' in più: ' + (spedOra ? 'spedizione gratis e 3 ebook in omaggio' : '3 ebook in omaggio') + '.' : ' con soli ' + euro(diff) + ' in più: ogni copia ti costa ' + euro(Math.round(prezzoLibro(a.copie) / a.copie)) + '.';
      html += '<div class="lc-car-su"><p><b>Passa a ' + esc(a.nome) + '</b>' + frase + '</p><button type="button" data-lc-copie="' + a.copie + '">Passa a ' + a.copie + '</button></div>';
    }
  }
  /* EBOOK NEL CARRELLO (Nicola, 31/10/2026 sera): oltre al passo in più, gli ebook che non sono già
     omaggio né nel carrello. Con la spedizione gratis da 39,90 € una copia + un ebook non paga la
     spedizione: se succede, lo si dice con la differenza vera. */
  if (copie > 0) {
    const reg = new Set(om.ebook.map(e => e.chiave));
    const dentro = new Set(cart.items.map(ebookDi).filter(Boolean).map(e => e.chiave));
    const liberi = EBOOK.filter(e => !reg.has(e.chiave) && !dentro.has(e.chiave));
    if (liberi.length) {
      const spedOra = spedizione(cart);
      let nota = '';
      if (spedOra && cart.total_price + liberi[0].prezzo >= CFG.soglia) {
        const diff = liberi[0].prezzo - spedOra;
        nota = '<p class="lc-cross-nota">Con un ebook la <b>spedizione diventa gratis</b>: ' + (diff > 0 ? 'in tutto paghi solo <b>' + euro(diff) + '</b> in più.' : 'paghi meno di adesso.') + '</p>';
      }
      html += '<div class="lc-car-cross"><h4>Aggiungi un ebook</h4>' + nota + '<ul>' + liberi.map(e =>
        '<li><img src="' + esc(e.mini || e.img) + '" alt="" width="42" height="59"><span class="lc-nome">' + esc(e.titolo) + '<small>PDF da stampare, nella mail di conferma</small></span>' +
        '<span class="lc-val"><s>' + euro(e.barrato) + '</s><b>' + euro(e.prezzo) + '</b><button type="button" data-lc-cross="' + e.variante + '">Aggiungi</button></span></li>').join('') + '</ul></div>';
    }
  }
  corpo.innerHTML = html;
  const sub = cart.items.reduce((s, it) => s + it.original_line_price, 0);
  const sped = spedizione(cart);
  const risp = cart.items.reduce((s, it) => {
    const o = isLibro(it) ? VAR[it.variant_id] : ebookDi(it);
    return s + (o ? Math.max(0, o.barrato - o.prezzo) * it.quantity : 0);
  }, 0) + (cart.total_discount || 0);
  const set = (sel, v, h) => { const el = $(sel, box); if (el) { if (h) el.innerHTML = v; else el.textContent = v; } };
  set('[data-lc-c-sub]', euro(sub));
  set('[data-lc-c-sped]', sped ? euro(sped) : '<span class="lc-gratis">Gratis</span>', true);
  const rigaSped = $('[data-lc-c-sped]', box); if (rigaSped) rigaSped.parentElement.hidden = !cart.items.some(it => it.requires_shipping);
  set('[data-lc-c-risp]', euro(risp));
  set('[data-lc-c-tot]', euro(cart.total_price + sped));
}
/* "CE L'HAI GIÀ IN OMAGGIO" (Nicola, 31/10/2026): sotto il pulsante di un ebook (scheda dell'ebook e
   home), se le copie del libro nel carrello lo regalano già, lo si dice prima del tocco */
function giaOmaggio(){
  const reg = new Set(omaggiPer(copieLibro(cart)).ebook.map(e => e.variante));
  $$('[data-lc-aggiungi][data-variante]').forEach(b => {
    const id = +b.dataset.variante;
    let nota = b.nextElementSibling && b.nextElementSibling.classList.contains('lc-gia-om') ? b.nextElementSibling : null;
    if (reg.has(id)) {
      if (!nota) { nota = document.createElement('p'); nota.className = 'lc-gia-om'; b.after(nota); }
      nota.textContent = 'Ce l’hai già in omaggio con le copie nel carrello.';
    } else if (nota) nota.remove();
  });
}
function disegna(){
  if (!cart) return;
  giaOmaggio();
  const n = copieTot(cart);
  $$('[data-lc-conta]').forEach(b => { b.textContent = n; b.classList.toggle('lc-on', n > 0); });
  $$('[data-lc-carrello]').forEach(disegnaIn);
}

/* il pannello non si fida della memoria: rilegge /cart.js all'apertura, al ritorno
   sulla pagina (anche dalla cassa) e quando la scheda torna visibile */
let inCorso = null;
function aggiorna(){
  if (!CFG.rotte) return Promise.resolve();
  if (inCorso) return inCorso;
  inCorso = caricaESistema().then(disegna).catch(() => {}).finally(() => { inCorso = null; });
  return inCorso;
}
document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') aggiorna(); });
addEventListener('pageshow', e => { if (e.persisted) aggiorna(); });

const pannello = () => document.getElementById('cart-drawer');
const velo = $('[data-lc-velo]');
function carrelloAperto(){ const d = pannello(); return !!(d && d.hasAttribute('open')); }
function apri(){
  const d = pannello();
  if (!d) { location.href = CFG.rotte.pagina; return; }
  disegna();
  if (typeof d.open === 'function') d.open();
  else customElements.whenDefined('theme-drawer').then(() => d.open());
}
function chiudi(){ const d = pannello(); if (d && typeof d.close === 'function') return d.close(); }
function sincronizza(){
  const aperto = carrelloAperto();
  blocca(aperto || lenteAperta());
  if (velo) velo.classList.toggle('lc-on', aperto && largo());
  aggiornaBarra();
}
document.addEventListener('theme-drawer:open', e => { sincronizza(); if (e.target === pannello()) aggiorna(); });
document.addEventListener('theme-drawer:close', sincronizza);
if (velo) velo.addEventListener('click', chiudi);
$$('[data-lc-apri-carrello]').forEach(b => b.addEventListener('click', e => { if (!pannello()) return; e.preventDefault(); apri(); }));

function occupato(on){ $$('[data-lc-carrello]').forEach(b => b.classList.toggle('lc-car-busy', on)); }
function errore(t){ $$('[data-lc-car-errore]').forEach(e => { e.textContent = t || ''; }); }

/* clic dentro il carrello: copie del libro, quantità degli altri articoli, rimuovi, chiudi */
document.addEventListener('click', async e => {
  const box = e.target.closest('[data-lc-carrello]'); if (!box) return;
  if (e.target.closest('[data-lc-chiudi-carrello]')) { e.preventDefault(); chiudi(); return; }
  /* carrello vuoto (collaudo 4/11/2026): sopra i 990 px Horizon riapre nella pagina dopo il pannello
     rimasto aperto, quindi prima si chiude e poi si cambia pagina */
  const vuoto = e.target.closest('.lc-car-vuoto a');
  if (vuoto && box.closest('dialog')) {
    e.preventDefault();
    await Promise.race([chiudi(), new Promise(r => setTimeout(r, 600))]);
    location.href = vuoto.href;
    return;
  }
  const c = e.target.closest('[data-lc-copie]'), q = e.target.closest('[data-lc-q]'), x = e.target.closest('[data-lc-cross]');
  if (!c && !q && !x) return;
  try {
    occupato(true); errore(''); tolti = [];
    if (c) {
      const N = Math.max(0, +c.dataset.lcCopie);
      await impostaCopie(N);
      const o = N >= 1 && N <= 3 ? perCopie(N) : null;
      if (o && $('.lc-carta')) scegli(o.id);
    }
    if (q) await api(CFG.rotte.update, { updates: { [q.dataset.key]: Math.max(0, +q.dataset.lcQ) } });
    if (x) await aggiungi(+x.dataset.lcCross);
    await caricaESistema();
  } catch (err) { errore(err.message); await carica().catch(() => {}); }
  finally { occupato(false); disegna(); }
});

/* Aggiungi al carrello (libro o ebook): apre il pannello e lascia la cliente dove si trova */
$$('[data-lc-aggiungi]').forEach(b => b.addEventListener('click', async () => {
  const id = +(b.dataset.variante || scelta);   // ebook: la sua variante; libro: l'offerta scelta
  if (!id) return;
  b.disabled = true;
  try {
    tolti = [];
    await aggiungi(id);
    await caricaESistema();
    apri();
  } catch (err) { avviso(err.message); }
  finally { b.disabled = false; }
}));

/* MENU A TENDINA (31/10/2026 sera): il pulsante a sinistra della testata apre Home, Il libro,
   Gli ebook, Traccia il tuo ordine. Si chiude toccando una voce, fuori dalla tendina o con Esc. */
const bMenu = $('[data-lc-menu]'), tendina = $('[data-lc-tendina]');
if (bMenu && tendina) {
  const menu = on => { tendina.hidden = !on; bMenu.setAttribute('aria-expanded', on ? 'true' : 'false'); bMenu.setAttribute('aria-label', on ? 'Chiudi il menu' : 'Apri il menu'); document.documentElement.classList.toggle('lc-menu-aperto', on); };
  bMenu.addEventListener('click', e => { e.stopPropagation(); menu(tendina.hidden); });
  tendina.addEventListener('click', e => { if (e.target.closest('a')) menu(false); });
  document.addEventListener('click', e => { if (!tendina.hidden && !e.target.closest('[data-lc-tendina]')) menu(false); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && !tendina.hidden) { menu(false); bMenu.focus(); } });
}

/* TRACCIA IL TUO ORDINE: apre la pagina di parcelsapp.com con il codice incollato */
const fTraccia = $('[data-lc-traccia]');
if (fTraccia) fTraccia.addEventListener('submit', e => {
  e.preventDefault();
  const codice = ($('input', fTraccia).value || '').replace(/\s+/g, '').trim();
  if (!codice) return;
  window.open('https://parcelsapp.com/it/tracking/' + encodeURIComponent(codice), '_blank', 'noopener');
});

disegna();
/* un carrello di prima (due righe "1 copia", un ebook già in omaggio) si sistema subito */
if (daSistemare(cart)) aggiorna();
/* Horizon sopra i 990 px riapre da solo il pannello lasciato aperto nella pagina prima:
   velo, blocco e barra si allineano subito */
sincronizza();
})();
